import React, { Component, Fragment, createRef } from "react";
import { Multiselect } from 'multiselect-react-dropdown';
import Select, { components } from "react-select";
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import AppContext from "../../contexts/AppContext";
import Progress from "./include/Progress";
import OnboardingSteps from "./include/OnboardingSteps";
import { getCheckoutStepsData, updateUserData, updateUserWithToken} from "../../services/user";
import { list as skillList } from "../../services/skill";
import "./include/SelectPlan.css";
//import { emptyString } from "react-select/src/utils";

const SliderWithTooltip = createSliderWithTooltip(Slider);

const selectInterest = [
    { value: 'me', label: 'Montenegro', image: '/images/interest.svg', checked: false},
    { value:'rs', label: 'Serbia', image: '/images/verified.png',  checked: false },
    { value:'ra', label: 'Serbia1', image: '/images/interest.svg',  checked: false },
    { value:'rb', label: 'Serbia2', image: '/images/verified.png',  checked: true },
    { value:'rc', label: 'Serbia3', image: '/images/interest.svg',  checked: true },
  ];

  const Option = (props) => {
    //   console.log(props)
    // console.log(props.isSelected)
    return (
      <div>
        <components.Option {...props}>
        <div className="interest-option-container">
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}     
          <div className="label-wrapper">
          <img src= {props.data.image} alt="interest-image" />
          <label>{props.label}</label>
            </div> 
          </div>
        </components.Option>
      </div>
    );
  };

const marks = {
  
  0: {
    style: {
      color: '#394a55',
    },
    label: <strong>None</strong>,
  },
  50: {
    style: {
      color: '#394a55',
    },
    label: <strong>Some</strong>,
  },
  100: {
    style: {
      color: '#394a55',
    },
    label: <strong>Lots</strong>,
  },
};

export class WritingJobs extends Component {
	constructor(){
        super();
        this.state = {
            interestText:"Choose up to 5 interests",
            loading: false,
            interests: [],
            whyProwriter: [],
            item: {},
            items: {
                user_industries: null,
                whyPW: null,
                category_id: '',
                freelancing_experience: null,
                step: 'writingJobs',
				how_did_you_find_us: null,
                user_email: localStorage.getItem('user_email'),
                selectedItem: 'Select',
                achiveItem: 'Select',
				freelanceWriting: 'Select',
                selectedSkillSet: [],
                selectedSkillSetValue: [],
                skillListId: []
            },
			interest : "0",
            reason: "0",
            freelance: "0",
            rowsToDisplay: 8,
            expanded: false,
            industry: [],
            whyPWReason: [],
            freelancingExperienceList: [],
            roles: [],
            errors: {},
			how_did_you_find_us_options: [],
			sliderValues: 50,
            skillList:[],
            optionSelected: null,
		},

        this.handleInterests = this.handleInterests.bind(this);
        this.handleWhyPW = this.handleWhyPW.bind(this);
        this.showMore = this.showMore.bind(this);
        localStorage.removeItem("subscriber_user_email"); 
	}

    handleChange = (selected) => {
        var options =[];
        console.log(selected);
        if(selected != null){
            if(selected.length > 5){
                this.context.state.showCodeMessage('You may only select up to 5 interests', 'error')
                return false;
            }else{
                    this.state.interestText =  selected.length > 0 ?selected.length + " of 5 selected interests" :"Choose up to 5 interests"
                    options =   selected.map(data =>data.value);
                    this.setState({
                    optionSelected: selected
                    });
            }
        }else{
            this.setState({ interests:[], interestText:"Choose up to 5 interests"})
            this.setState({
                optionSelected: selected
            });
            options =   [];
    }
        let temp = this.state.items;
        temp['user_industries'] = (options.length > 0 && options.length <= 5) ? options.join(',') : null;
        // update the state with the new array of options
        this.setState({ interests: options, items: temp })
        console.log( temp['user_industries']); 
      };
	
    handleSkillChange = (field, item) => {
        
        let skillListIdDetails = [];
        if (this.state.skillList.length != 0) {
            for(var i=0; i<this.state.skillList.length; i++) {
                skillListIdDetails.push(this.state.skillList[i]['id']);
            }
        }

        let temp = this.state.items;
        temp.skillListId = skillListIdDetails;
        this.setState({ items: temp });

        if (skillListIdDetails.indexOf(item.id) !== -1) {
            let temp = this.state.items;

            let existingIndex = temp.selectedSkillSet.indexOf(item.id);

            if (existingIndex > -1) {
                temp.selectedSkillSet.splice(existingIndex, 1);
                temp.selectedSkillSetValue.splice(existingIndex, 1);
            }
            temp.selectedSkillSet.push(item.id);
            temp.selectedSkillSetValue.push(field);

            // let a = [...new Set(temp.selectedSkillSet)];
            // let b = [...new Set(temp.selectedSkillSetValue)];
            // console.log(a,b);
            let error = this.state.errors;
            // error.seo_slider = null;
            this.setState({ items: temp, errors: error });
        }
    }
	
	showMore = () => {
        this.state.rowsToDisplay === 8 ? (
            this.setState({ rowsToDisplay: this.state.industry.length, expanded: true })
        ) : (
            this.setState({ rowsToDisplay: 8, expanded: false })
        )
    }

	checkInterest = Id => {
		this.setState({ interest: this.state.interest === Id ? "0" : Id });
    }

    whatBrings = Id => {
        this.setState({ reason: this.state.reason === Id ? "0" : Id });
    }

    freelanceExp = Id => {
        this.setState({ freelance: this.state.freelance === Id ? "0" : Id });
    }

    handleInterests = (e) => {
        // current array of options
        const options = this.state.interests
        let index


        if (options.length < 5) {
            if (e.target.checked) {
                options.push(+e.target.value)
            } else {
                index = options.indexOf(+e.target.value)
                options.splice(index, 1)
            }
        } else {
            if (options.length >= 5) {
                if (e.target.checked) {
                    e.target.checked = false;
                    e.preventDefault();
                    this.context.state.showCodeMessage('You may only select up to 5 interests', 'error')
                } else {
                    index = options.indexOf(+e.target.value)
                    options.splice(index, 1)
                }
            }
        }

        let temp = this.state.items;
        temp['user_industries'] = (options.length > 0 && options.length <= 5) ? options.join(',') : null;
        // update the state with the new array of options
        this.setState({ interests: options, items: temp })
        //console.log(this.state.interests);
        console.log( temp['user_industries']); 
    }



    handleWhyPW = (e) => {
        // current array of options
        const options = this.state.whyProwriter
        let index

        // check if the check box is checked or unchecked
        if (e.target.checked) {
            // add the numerical value of the checkbox to options array
            options.push(+e.target.value)
        } else {
            // or remove the value from the unchecked checkbox from the array
            index = options.indexOf(+e.target.value)
            options.splice(index, 1)
        }
        let temp = this.state.items;
        temp['whyPW'] = options.length > 0 ? options.join(',') : null;
        // update the state with the new array of options
        this.setState({ whyProwriter: options, items: temp })

    }

    handleSubmit = e => {
        e.preventDefault();
        this.setState({ loading: true });

        updateUserData(this.state.items)
            .then(res => {
                this.setState({ loading: false });
                //this.context.state.showCodeMessage(res.message,'success'); 
                if (res.meta == 'success') {
                    localStorage.setItem("user_steps", "select_plan");
                    this.props.history.push('/process/select-plan/');
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                this.context.state.handelError(error);
            });
    };

    onChange = field => {
        let temp = this.state.items;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ items: temp, errors: error });
    };

    onSelect = (selectedList, selectedItem) => {
        let result = selectedList.map(a => a.value);
        let temp = this.state.item;
        temp['category_id'] = result.length > 0 ? result.join(',') : null;

        let error = this.state.errors;
        error['category_id'] = null;
        this.setState({ item: temp, errors: error });
    }

    onRemove = (selectedList, selectedItem) => {
        let result = selectedList.map(a => a.value);
        let temp = this.state.item;
        temp['category_id'] = result.length > 0 ? result.join(',') : null;

        let error = this.state.errors;
        error['category_id'] = null;
        this.setState({ item: temp, errors: error });
    }
	
	handleHowDidYouFindUsSelectChange = selectedOption => {
        let temp = this.state.items;
        temp.how_did_you_find_us = selectedOption.value;
        temp.selectedItem = selectedOption.name;
        let error = this.state.errors;
        error.how_did_you_find_us = null;
        this.setState({ items: temp, errors: error });
    }
	
	handleYouLikeToAchiveSelectChange = selectedOption => {
        let temp = this.state.items;
        temp.whyPW = selectedOption.value;
        temp.achiveItem = selectedOption.name;
        let error = this.state.errors;
        error.whyPW = null;
        this.setState({ items: temp, errors: error });
    }
	
	freelanceWritingSelectChange = selectedOption => {
        let temp = this.state.items;
        temp.freelancing_experience = selectedOption.value;
        temp.freelanceWriting = selectedOption.name;
        let error = this.state.errors;
        error.freelancing_experience = null;
        this.setState({ items: temp, errors: error });
    }

    componentDidMount() {
        this.context.state.updateMetaData('writing-jobs');

        getCheckoutStepsData({ token: "", type: 'pwonbs1' })
            .then(res => {
                if (res.status === true) {
                    
                    this.setState({
                        item: res.data,
                        industry: res.meta.industries,
                        whyPWReason: res.meta.checkout_steps_data.whyPw,
                        roles: res.meta.categories,
                        freelancingExperienceList: res.meta.checkout_steps_data.freelanceWritingExperience,
						how_did_you_find_us_options: res.meta.checkout_steps_data.howDidYouHear,
                    });
                   // console.log(this.state.whyPWReason);
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });

        skillList()
            .then(res => {
                this.setState({ skillList: res.data });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
	
	render() {
		
		//const { sliderValues } = this.state;
		
		return (
            <Fragment>
			    <section className="checkout-process resp-checkout-process py-md-6 py-sm-5 py-4">
				    <div className="container">	
					    <div className="sub-container mx-auto">
				            <div className="row no-gutters">
				                <div className="col-xl-3 col-lg-4 col-md-4">
				            	    <OnboardingSteps onboardStep="[1,2]" show="2"></OnboardingSteps>
				            	</div>
				            	<div className="col-xl-9 col-lg-8 col-md-8">
				            	    <div className="bg-white checkout new">
									    <div className="create-profile mx-auto mb-3 p-0">
										    <div className="title">
											    <img className="mx-auto d-block mb-3" width="30" height="46" src="/images/logo_dark.png" alt="pw-logo"/>
												<h2 className="text-center mb-3">Ready to land your first writing job!?</h2>
												<p className="text-center mb-4">We'll recommend writing jobs based on your interests and experience.</p>
											</div>
											<Progress ariavalue="50" content="Step 2 of 3...." width="50%"></Progress>
                                            <h3 className="mt-5 mb-2 text-md-left text-center">Select your interests</h3>
                                            <p className="text-dark d-flex flex-md-row flex-column align-items-center justify-content-md-between justify-content-center">
                                                <span className="mb-md-4 mb-2 text-md-left text-center">We'll help you find and land writing gigs in your interests.</span>
                                                <span className="mb-4">{this.state.interestText}:</span>
                                            </p>
                                            {/* <div className="row flex-wrap pb-md-4 pb-3 flex-sm-row flex-column align-items-center justify-content-center">
                                                this.state.industry.slice(0, this.state.rowsToDisplay).map((item, i) =>
                                                {this.state.industry.map((item, i) =>
                                                <div key={i} className={this.context.state.inArray(item.id, this.state.interests) ? "col-sm-auto col-12 mb-3 px-2 interest-block active" : "col-sm-auto col-12 mb-3 px-2 interest-block"}>
                                                    <div className="position-relative custom-control custom-checkbox">
                                                        <input onChange={this.handleInterests} type="checkbox" className="custom-control-input" name="interest" id={`customCheck${item.id}`} value={item.id} />
                                                        <label className="custom-control-label d-flex align-items-center py-2 px-3" htmlFor={`customCheck${item.id}`}>
                                                            <div className="img-container mr-2">
                                                                <img className="d-block" src={item.icon_image} loading="lazy" alt={item.name} title={item.name} />
															</div>
                                                            <p className="text-center pr-1">{item.name}</p>
                                                        </label>
                                                    </div>
                                                </div>
                                                )}
                                               {
                                                    this.state.industry.length > 8 ?
                                                        <div className="col-12">
                                                            <button type="button" className={`btn continue btn-primary ${this.state.expanded ? `grey` : ``} border-0 d-block mx-auto`} onClick={this.showMore}>Show {this.state.expanded ? `less` : `more`}</button>
                                                        </div>
                                                        : null
                                                } 
                                            </div> */}
                                            <Select
                                              isMulti
                                              className="custom-multiselect form-control m-input select center-select pr-5 mb-5" 
                                            //   value={selectInterest.value}
                                              value={this.state.optionSelected}
                                              allowSelectAll={true}
                                              options={this.state.industry}
                                            //   options={selectInterest}
                                              closeMenuOnSelect={false}
                                              placeholder= "Select"
                                              onChange={this.handleChange}
                                              hideSelectedOptions= {false}
                                              components={{
                                                Option
                                              }}
                                              
                                              formatOptionLabel={interest => (
                                                <div className="interest-option">
                                                  <img src={interest.image} alt="interest-image" />
                                                  <span>{interest.label}</span>
                                                </div>
                                              )}
                                              styles={{
                                                option: base => ({
                                                  ...base,
                                                  height: '100%',
                                                }),
                                                placeholder: (base, state) => ({
                                                  ...base,
                                                  textOverflow: "ellipsis",
                                                  maxWidth: "97%",
                                                  whiteSpace: "nowrap",
                                                  overflow: "hidden",
                                                  display: "initial",
                                                  padding: "5px 0"
                                                })
                                              }}
                                              menuPlacement="bottom"
                                            /> 
											<h3 className="mt-4 mb-3 text-md-left text-center">How long have you been freelance writing?</h3>
											<div className="form-group select mb-5">
				                                <Select 
                                                           className="form-control m-input center-select pr-5" 
                                                            name="freelancing_experience"
                                                            id="freelancing_experience"
                                                            value={this.state.items.freelancing_experience}
                                                            placeholder = {this.state.items.freelanceWriting}  
                                                            ref="freelancing_experience"
                                                            onChange={(val) => this.freelanceWritingSelectChange(val)}
                                                            options={
                                                                this.state.freelancingExperienceList
                                                            }
															styles={{
                                                              option: base => ({
                                                                ...base,
                                                                height: '100%',
															  }),
															  placeholder: (base, state) => ({
                                                                ...base,
                                                                textOverflow: "ellipsis",
                                                                maxWidth: "97%",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                display: "initial",
																padding: "5px 0"
                                                              })
                                                            }}
															menuPlacement="bottom"
                                                ></Select>
				                            		{this.state.errors.freelance_writing_options ? (
				                            			<div className="invalid-feedback">
				                            				{this.state.errors.freelance_writing_options}
				                            			</div>
				                            		) : null}
				                            </div>
											
											{/*<div className="row reasons flex-column align-items-center">
                                                {this.state.freelancingExperienceList.map((v, i) =>
                                                    <div className="col-12 text-center mb-4" key={i}>
                                                        <div className={`border py-3 pr-4 pl-3 d-inline-block ${this.state.freelance === v.id ? `active` : ``}`}>
                                                            <div className="position-relative custom-control custom-radio">
                                                                <input type="radio" onChange={this.onChange} className="custom-control-input" name="freelancing_experience" id={`free${v.id}`} value={v.id} />
                                                                <label onClick={() => this.freelanceExp(v.id)} className="custom-control-label" htmlFor={`free${v.id}`}>
                                                                    {v.name}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
	                                        </div>*/}
											
											<h3 className="mt-4 mb-3 text-md-left text-center">What would you like to achieve with ProWriter?</h3>
                                            <div className="form-group select mb-5">
				                                <Select 
                                                    className="form-control m-input center-select pr-5" 
                                                    name="whyPW"
                                                    id="whyPW"
                                                    value={this.state.items.whyPW}
                                                    placeholder = {this.state.items.achiveItem}  
                                                    ref="whyPW"
                                                    onChange={(val) => this.handleYouLikeToAchiveSelectChange(val)}
                                                    options={
                                                        this.state.whyPWReason
                                                    }
													styles={{
                                                      option: base => ({
                                                        ...base,
                                                        height: '100%',
                                                      }),
													  placeholder: (base, state) => ({
                                                        ...base,
                                                        textOverflow: "ellipsis",
                                                        maxWidth: "97%",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        display: "initial",
														padding: "5px 0"
                                                      })
                                                    }}
													menuPlacement="bottom"
                                                ></Select>
                                                {this.state.errors.whyPW ? (
				                            			<div className="invalid-feedback">
                                                        {this.state.errors.whyPW}
				                            			</div>
				                            		) : null}
				                            </div>
											
											{/*<div className="row reasons flex-column align-items-center">
                                                {this.state.whyPWReason.map((v, i) =>
                                                    <div className="col-12 text-center mb-4" key={i}>
                                                        <div className={this.state.reason === v.id ? "border py-3 pr-4 pl-3 d-inline-block active" : "border py-3 pr-4 pl-3 d-inline-block"}>
                                                            <div className="position-relative custom-control custom-radio">
                                                                <input type="radio" onChange={this.onChange} className="custom-control-input" name="whyPW" id={v.id} value={v.id} />
                                                                <label onClick={() => this.whatBrings(v.id)} className="custom-control-label" htmlFor={v.id}>
                                                                    {v.name}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
	                                        </div>*/}
											
											<h3 className="mt-4 mb-3 text-md-left text-center">How did you hear about ProWriter?</h3>				
                                            <div className="form-group select mb-5">
				                                <Select 
                                                    className="form-control m-input center-select pr-5" 
                                                     name="how_did_you_find_us"
                                                     id="how_did_you_find_us" 
                                                     value={this.state.items.how_did_you_find_us}   
                                                     placeholder = {this.state.items.selectedItem}  
				                            		ref="how_did_you_find_us"
                                                     onChange={(val) => this.handleHowDidYouFindUsSelectChange(val)}
                                                     options={
                                                         this.state.how_did_you_find_us_options
                                                     }
													styles={{
                                                       option: base => ({
                                                         ...base,
                                                         height: '100%',
                                                       }),
													   placeholder: (base, state) => ({
                                                         ...base,
                                                         textOverflow: "ellipsis",
                                                         maxWidth: "97%",
                                                         whiteSpace: "nowrap",
                                                         overflow: "hidden",
                                                         display: "initial",
														 padding: "5px 0"
                                                       })
                                                     }}
													menuPlacement="top"
                                                ></Select>
				                            		{this.state.errors.how_did_you_find_us ? (
				                            			<div className="invalid-feedback">
				                            				{this.state.errors.how_did_you_find_us}
				                            			</div>
				                            		) : null}
				                            </div>
											
											<h3 className="mt-4 mb-4 text-md-left text-center">What is your writing skill experience with...</h3>				
                                            
                                            <div className="row my-skill">
                                                
                                                {this.state.skillList.map((item, i) =>
                                                    <Fragment key={i}>
                                                        <div className="col-lg-3 col-md-5 mb-md-5 mb-3">
                                                            <h3 className="font-weight-bold text-md-right text-center font-large">{item.name}</h3>
                                                        </div>
                                                        <div className="col-lg-9 col-md-7 mb-5">
                                                            <div className="skill-slider-container">
                                                                <Slider
                                                                    dots
                                                                    step={50}
                                                                    name={item.id}
                                                                    id={item.id}
                                                                    defaultValue={this.state.sliderValues}
                                                                    onChange={(value) => this.handleSkillChange(value, item)}
                                                                    dotStyle={{
                                                                        borderColor: '#94b2c0',
                                                                        borderWidth: '4px',
                                                                        height: '20px',
                                                                        width: '20px',
                                                                        top: '-8px',
                                                                        marginLeft: '-11px'
                                                                    }}
                                                                    railStyle={{ backgroundColor: '#94b2c0' }}
                                                                    handleStyle={{
                                                                        height: 20,
                                                                        width: 20,
                                                                        backgroundColor: '#1dd2ad',
                                                                        marginTop: -8,
                                                                        marginLeft: -1
                                                                    }}
                                                                    activeDotStyle={{ borderColor: '#94b2c0' }}
                                                                    included={false}
                                                                    marks={marks}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                )}
											</div>
											<div className="mt-5 text-center">
                                                <button type="button" onClick={this.handleSubmit} disabled={this.state.loading} className="btn continue btn-primary border-0 mb-md-0 mb-3"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : null}></i> {this.state.loading ? `Processing...` : `Continue To Final Step!`}</button>
                                            </div>
                                        </div>
									</div>
				            	</div>
				            </div>
						</div>	
					</div>
				</section>
			</Fragment>
		);
	}	
}

WritingJobs.contextType = AppContext;
export default WritingJobs;	


// WEBPACK FOOTER //
// ./src/components/general/WritingJobs.js